// extracted by mini-css-extract-plugin
export var chatArea = "styles-module--chatArea--7c5f0";
export var footer = "styles-module--footer--174fa";
export var header = "styles-module--header--a5daa";